import React from 'react';
import './SearchBar.css';

const SearchBar = ({
  value,
  onChange,
  category,
  onCategoryChange,
}) => {
  return (
    <div className="cf-search-bar">
      <label htmlFor="course-search" className="cf-search-label">
        Search by course name or category
      </label>
      <div className="cf-search-row">
        <input
          id="course-search"
          type="text"
          className="cf-search-input"
          placeholder="e.g. React, Backend, Design..."
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <select
          id="category-filter"
          className="cf-filter-select"
          value={category}
          onChange={(e) => onCategoryChange(e.target.value)}
        >
          <option value="all">All categories</option>
          <option value="Frontend">Frontend</option>
          <option value="Backend">Backend</option>
          <option value="Fullstack">Fullstack</option>
          <option value="Programming">Programming</option>
          <option value="Design">Design</option>
          <option value="DevOps">DevOps</option>
          <option value="Product">Product</option>
        </select>
      </div>
    </div>
  );
};

export default SearchBar;


